import "./style.scss";
import * as React from "react";
import * as _ from "lodash";
import moment from "moment-timezone";

import Section from "../../../../core/Section";
import Row from "../../../../core/Row";
import Button from "../../../../core/Button";
import { Popover, Icon } from "antd";
import { Select, DatePicker, Checkbox, Radio } from "../../../../form";
import StartDatePopover from "./StartDatePopover";
import SchedulePopover from "./SchedulePopover";
const EASTERN_ZONE = "America/New_York";
const PACIFIC_ZONE = "America/Los_Angeles";
const TIMEZONE_SELECT = [
  { value: EASTERN_ZONE, label: "Eastern Time" },
  { value: PACIFIC_ZONE, label: "Pacific Time" }
];

class ReportSchedule extends React.Component<any, any> {
  disabledHours() {
    // utc time lock
    let utcTimelock = [5, 6, 7, 8, 9, 10];
    let tzOffset = this.props.time._offset / 60;
    return utcTimelock.map((hr: number) => {
      let adjustedTime = hr + tzOffset;
      return adjustedTime >= 0 ? adjustedTime : adjustedTime + 24;
    });
  }

  renderPreview() {
    if (!this.props.enabled) {
      return "Report is disabled and will not be sent.";
    } else if (this.props.start) {
      return (
        "Next Report will be sent on " +
        moment(this.props.start).format("YYYY-MM-DD") +
        " @ " +
        moment(this.props.time).format("HH:mm:ss a")
      );
    } else {
      return "Please select a start date";
    }
  }

  render() {
    return (
      <Section className="report-schedule">
        <div className="scheduler-header">Data Delivery Schedule</div>
        <div className="scheduler-footer">
          Note: Files will be delivered on the selected day as soon as it is
          available. Although delivery times will vary, files will typically be
          delivered between 7:00AM and 10:00AM EST.
        </div>
        <Row>
          <div className="label left">
            <Radio
              label="Repeats daily"
              checked={this.props.type === "daily"}
              handleChange={this.props.toggleDaily}
            />
            {/* 
            Temporarily hiding time pickers as a part of RR-652.
            All reports will be sent at the earliest possible time 7AM EST. 
            This value is set on reducer level. 
            <div className="details right">

            <DatePicker
              mode="time"
              name="time"
              disabledHours={this.disabledHours.bind(this)}
              value={this.props.time}
              disabled={this.props.type !== "daily"}
              handleChange={(e: any) => this.props.editTime(e.target.value)}
              hideDisabledOptions={true}
            />
            <Select
              options={TIMEZONE_SELECT}
              value={this.props.timezone}
              disabled={this.props.type !== "daily"}
              handleChange={(e: any) => this.props.editTimezone(e.target.value)}
            /> */}
            &nbsp;&nbsp;&nbsp;
            <Popover
              placement="topLeft"
              content={
                <SchedulePopover
                  popover_type="daily"
                  time_zone={this.props.timezone}
                />
              }
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
        </Row>

        <Row>
          <div className="label left">
            <Radio
              label="Repeats weekly on"
              checked={this.props.type === "weekly"}
              handleChange={this.props.toggleWeekly}
            />
          </div>

          <div className="details right">
            <Select
              className="form-length"
              name="day"
              disabled={this.props.type !== "weekly"}
              handleChange={(e: any) => this.props.editDay(e.target.value)}
              value={this.props.day}
              options={[
                { value: "0", label: "Sunday" },
                { value: "1", label: "Monday" },
                { value: "2", label: "Tuesday" },
                { value: "3", label: "Wednesday" },
                { value: "4", label: "Thursday" },
                { value: "5", label: "Friday" },
                { value: "6", label: "Saturday" }
              ]}
            />
            {/*
            Temporarily hiding time pickers as a part of RR-652.
            All reports will be sent at the earliest possible time 7AM EST. 
            This value is set on reducer level. 
            <div className="time-picker-seperator">
              at
            </div>

            <DatePicker
              mode="time"
              name="time"
              disabledHours={this.disabledHours.bind(this)}
              value={this.props.time}
              disabled={this.props.type !== "weekly"}
              handleChange={(e: any) => this.props.editTime(e.target.value)}
              hideDisabledOptions={true}
            />
            
            <Select
              options={TIMEZONE_SELECT}
              value={this.props.timezone}
              disabled={this.props.type !== "weekly"}
              handleChange={(e: any) => this.props.editTimezone(e.target.value)}
            />*/}
            &nbsp;&nbsp;&nbsp;
            <Popover
              content={
                <SchedulePopover
                  popover_type="weekly"
                  time_zone={this.props.timezone}
                />
              }
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
        </Row>

        <Row>
          <div className="label left">
            <Radio
              label="Repeats monthly on day"
              checked={this.props.type === "monthly"}
              handleChange={this.props.toggleMonthly}
            />
          </div>

          <div className="details right">
            <Select
              className="form-length"
              name="day"
              disabled={this.props.type !== "monthly"}
              value={this.props.day}
              handleChange={(e: any) => this.props.editDay(e.target.value)}
              options={_.times(28, (i: number) => {
                return { label: (i + 1).toString(), value: (i + 1).toString() };
              })}
            />
            {/* 
            Temporarily hiding time pickers as a part of RR-652.
            All reports will be sent at the earliest possible time 7AM EST. 
            This value is set on reducer level. 
            <div className="time-picker-seperator">
              at
            </div>

            <DatePicker
              mode="time"
              name="time"
              disabledHours={this.disabledHours.bind(this)}
              value={this.props.time}
              disabled={this.props.type !== "monthly"}
              handleChange={(e: any) => this.props.editTime(e.target.value)}
              hideDisabledOptions={true}
            />
  
            <Select
              options={TIMEZONE_SELECT}
              value={this.props.timezone}
              disabled={this.props.type !== "monthly"}
              handleChange={(e: any) => this.props.editTimezone(e.target.value)}
            /> */}
            &nbsp;&nbsp;&nbsp;
            <Popover
              content={
                <SchedulePopover
                  day={this.props.day}
                  popover_type="monthly"
                  time_zone={this.props.timezone}
                />
              }
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
        </Row>

        <h3>Export Start Date</h3>
        <Row>
          <Checkbox
            label="Enabled"
            checked={this.props.enabled}
            handleChange={() => this.props.toggleEnabled()}
          />
          <DatePicker
            name="delayed"
            value={this.props.start}
            handleChange={(e: any) => this.props.editStart(e.target.value)}
            disabledDate={(cur: any) => {
              // can not select days before today and today
              return cur && cur.valueOf() < new Date().setHours(0, 0, 0, 0);
            }}
            showToday={false}
          />
          &nbsp;
          <Button type="primary" onClick={() => this.props.editStart(moment())}>
            Set to Today
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Popover content={<StartDatePopover />} title="Help" trigger="hover">
            <Icon type="question-circle" />
          </Popover>
        </Row>

        {/*TODO: fix logic to account for day of the week*/}
        {/*<Row>
          <h4>{this.renderPreview()}</h4>
        </Row>*/}
      </Section>
    );
  }
}

export default ReportSchedule;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportSchedule/component.tsx